import type { WidgetDomElements } from './dom';

export interface WidgetEventHandlers {
  onToggle: () => void;
  onClose: () => void;
  onReconnect: () => void;
  onEndChat: () => void;
}

export interface WidgetEventBindings {
  detach(): void;
}

export function bindWidgetEvents(
  elements: WidgetDomElements,
  handlers: WidgetEventHandlers,
): WidgetEventBindings {
  const handleToggleClick = (): void => handlers.onToggle();
  const handleCloseClick = (): void => handlers.onClose();
  const handleReconnectClick = (): void => handlers.onReconnect();

  function closeOverflowMenu(): void {
    elements.overflowMenu.hidden = true;
    elements.overflowButton.setAttribute('aria-expanded', 'false');
  }

  const handleEndChatClick = (): void => {
    closeOverflowMenu();
    handlers.onEndChat();
  };

  const handleOverflowToggle = (): void => {
    const nextHidden = !elements.overflowMenu.hidden;
    elements.overflowMenu.hidden = nextHidden;
    elements.overflowButton.setAttribute('aria-expanded', String(!nextHidden));
  };

  const handleDocumentClick = (event: MouseEvent): void => {
    if (elements.overflowMenu.hidden) {
      return;
    }

    const target = event.target as Node;

    if (!elements.overflowMenu.contains(target) && !elements.overflowButton.contains(target)) {
      closeOverflowMenu();
    }
  };

  const handleKeyDown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') {
      return;
    }

    if (!elements.overflowMenu.hidden) {
      closeOverflowMenu();
      return;
    }

    handlers.onClose();
  };

  elements.floatingButton.addEventListener('click', handleToggleClick);
  elements.closeButton.addEventListener('click', handleCloseClick);
  elements.reconnectBanner.addEventListener('click', handleReconnectClick);
  elements.endChatButton.addEventListener('click', handleEndChatClick);
  elements.overflowButton.addEventListener('click', handleOverflowToggle);
  document.addEventListener('click', handleDocumentClick);
  document.addEventListener('keydown', handleKeyDown);

  return {
    detach(): void {
      elements.floatingButton.removeEventListener('click', handleToggleClick);
      elements.closeButton.removeEventListener('click', handleCloseClick);
      elements.reconnectBanner.removeEventListener('click', handleReconnectClick);
      elements.endChatButton.removeEventListener('click', handleEndChatClick);
      elements.overflowButton.removeEventListener('click', handleOverflowToggle);
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleKeyDown);
    },
  };
}
